var $87d3ccd5e347c7cc$exports = {};
$87d3ccd5e347c7cc$exports = {
  "dragDescriptionKeyboard": "Aloita vet\xE4minen painamalla Enter-n\xE4pp\xE4int\xE4.",
  "dragDescriptionKeyboardAlt": "Aloita vet\xE4minen painamalla Alt + Enter -n\xE4pp\xE4inyhdistelm\xE4\xE4.",
  "dragDescriptionLongPress": "Aloita vet\xE4minen pit\xE4m\xE4ll\xE4 painettuna.",
  "dragDescriptionTouch": "Aloita vet\xE4minen kaksoisnapauttamalla.",
  "dragDescriptionVirtual": "Aloita vet\xE4minen napsauttamalla.",
  "dragItem": function dragItem(args) {
    return "Ved\xE4 kohdetta ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "Ved\xE4 ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " valittua kohdetta");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " valittua kohdetta");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Ved\xE4 painamalla Enter ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " valittu kohde");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " valittua kohdetta");
      }
    }), ".");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Ved\xE4 painamalla Alt + Enter ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " valittu kohde");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " valittua kohdetta");
      }
    }), ".");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Ved\xE4 pit\xE4m\xE4ll\xE4 painettuna ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " valittu kohde");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " valittua kohdetta");
      }
    }), ".");
  },
  "dragStartedKeyboard": "Vet\xE4minen aloitettu. Siirry pudotuskohteeseen painamalla sarkainn\xE4pp\xE4int\xE4 ja sitten pudota painamalla Enter-n\xE4pp\xE4int\xE4 tai peruuta painamalla Escape-n\xE4pp\xE4int\xE4.",
  "dragStartedTouch": "Vet\xE4minen aloitettu. Siirry pudotuskohteeseen ja pudota kaksoisnapauttamalla.",
  "dragStartedVirtual": "Vet\xE4minen aloitettu. Siirry pudotuskohteeseen ja pudota napsauttamalla tai painamalla Enter-n\xE4pp\xE4int\xE4.",
  "dropCanceled": "Pudotus peruutettu.",
  "dropComplete": "Pudotus suoritettu.",
  "dropDescriptionKeyboard": "Pudota painamalla Enter-n\xE4pp\xE4int\xE4. Peruuta vet\xE4minen painamalla Escape-n\xE4pp\xE4int\xE4.",
  "dropDescriptionTouch": "Pudota kaksoisnapauttamalla.",
  "dropDescriptionVirtual": "Pudota napsauttamalla.",
  "dropIndicator": "pudotuksen ilmaisin",
  "dropOnItem": function dropOnItem(args) {
    return "Pudota kohteeseen ".concat(args.itemText);
  },
  "dropOnRoot": "Pudota kohteeseen",
  "endDragKeyboard": "Vedet\xE4\xE4n. Peruuta vet\xE4minen painamalla Enter-n\xE4pp\xE4int\xE4.",
  "endDragTouch": "Vedet\xE4\xE4n. Peruuta vet\xE4minen kaksoisnapauttamalla.",
  "endDragVirtual": "Vedet\xE4\xE4n. Peruuta vet\xE4minen napsauttamalla.",
  "insertAfter": function insertAfter(args) {
    return "Lis\xE4\xE4 kohteen ".concat(args.itemText, " j\xE4lkeen");
  },
  "insertBefore": function insertBefore(args) {
    return "Lis\xE4\xE4 ennen kohdetta ".concat(args.itemText);
  },
  "insertBetween": function insertBetween(args) {
    return "Lis\xE4\xE4 kohteiden ".concat(args.beforeItemText, " ja ").concat(args.afterItemText, " v\xE4liin");
  }
};
export { $87d3ccd5e347c7cc$exports as default };